import { Button } from "@aviary";
import type { Brand } from "@shared/components/CatalogSearch/CatalogSearch";
import { TrayColumns, TrayColumnItem } from "@shared/components/CatalogSearch/TrayColumns";
import type { BrandSplinter } from "@shared/data/queries/BrandsQuery";

import * as styles from "./BrandsList.styles";

interface Props {
  brands: BrandSplinter[];
  onBrandClick: (brand: Brand) => void;
  columnCount?: number;
}

const BrandsList = ({ brands, onBrandClick, columnCount }: Props) => {
  const renderBrands = () => {
    return brands?.map(brand => (
      <TrayColumnItem key={brand.id}>
        <Button noStyle onClick={() => onBrandClick(brand)} css={styles.listItem}>
          {brand.name}
        </Button>
      </TrayColumnItem>
    ));
  };

  return <TrayColumns columnCount={columnCount}>{renderBrands()}</TrayColumns>;
};

export { BrandsList };
